// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Dropdown List Component */
:host {
  display: block;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: var(--ids-input-width-40);
  min-width: calc(var(--ids-input-width-10) - 2px);
  width: var(--ids-input-width-full);
  font-weight: normal;
}

:host(.multi-column) {
  overflow-x: auto;
}

:host(.is-table) {
  display: table;
}

:host(.is-datagrid[field-height=xs]) ::slotted(ids-list-box-option),
:host(.is-datagrid[field-height=xxs]) ::slotted(ids-list-box-option) {
  font-size: var(--ids-font-size-xs);
}

:host([size=xs]),
:host([size=xs]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-10) - 2px);
}

:host([disabled]:not([disabled=false])) {
  cursor: var(--ids-cursor-default);
  opacity: 0.5;
  pointer-events: none;
}

:host([size=sm]),
:host([size=sm]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-20) - 2px);
}

:host([size=md]),
:host([size=md]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-40) - 2px);
  min-height: 32px;
}

:host([size=mm]),
:host([size=mm]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-30) - 2px);
}

:host([size=lg]),
:host([size=lg]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-50) - 2px);
}

:host([size=full]),
:host([size=full]) ::slotted(ids-list-box-option) {
  max-width: var(--ids-input-width-full);
}

:host([auto-size=true]),
:host([auto-size=true]) ::slotted(ids-list-box-option) {
  max-width: none;
}

:host([input-auto-size=false]) ::slotted(ids-list-box-option) {
  margin-inline-end: 8px;
}

:host([field-height=xxs]) ::slotted(ids-list-box-option) {
  font-size: var(--ids-dropdown-font-size-compact);
  min-height: calc(var(--ids-input-height-10) - 2px);
  line-height: calc(var(--ids-input-height-10) - 2px);
  text-indent: 2px;
}

:host([compact]) ::slotted(ids-list-box-option),
:host([field-height=xs]) ::slotted(ids-list-box-option) {
  font-size: var(--ids-dropdown-font-size-compact);
  min-height: calc(var(--ids-input-height-10) - 2px);
  line-height: calc(var(--ids-input-height-10) - 2px);
  text-indent: 4px;
}

:host([field-height=sm]) ::slotted(ids-list-box-option) {
  min-height: calc(var(--ids-input-height-20) - 2px);
  line-height: calc(var(--ids-input-height-20) - 2px);
  text-indent: 10px;
}

:host([field-height=md]) ::slotted(ids-list-box-option) {
  min-height: calc(var(--ids-input-height-30) - 2px);
  line-height: calc(var(--ids-input-height-30) - 2px);
}

:host([field-height=lg]) ::slotted(ids-list-box-option) {
  min-height: calc(var(--ids-input-height-40) - 2px);
  line-height: calc(var(--ids-input-height-40) - 2px);
}

:host([uppercase]) ::slotted(ids-list-box-option) {
  text-transform: uppercase;
}

:host(.module-nav) {
  max-height: none;
}

:host(ids-list-box) ids-text.first-selected {
  display: block;
  padding: 5px 9px;
}

::slotted(ids-text.first-selected) {
  display: block;
  padding: 5px 9px;
}

::slotted(ids-list-box-option[selected].last-selected) {
  margin-bottom: var(--ids-dropdown-group-padding);
}

::slotted(ids-list-box-option.ellipsis) {
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-list-box/ids-list-box.scss"],"names":[],"mappings":"AAAA,gCAAA;AAaA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,gDAfqB;EAgBrB,kCAAA;EACA,mBAAA;AAXF;;AAcA;EACE,gBAAA;AAXF;;AAcA;EACE,cAAA;AAXF;;AAgBE;;EACE,kCAAA;AAZJ;;AAkBE;;EAEE,gDAvCmB;AAwBvB;;AAmBA;EACE,iCAAA;EACA,YAAA;EACA,oBAAA;AAhBF;;AAoBE;;EAEE,gDAnDmB;AAkCvB;;AAsBE;;EAEE,gDAzDmB;EA0DnB,gBAAA;AAnBJ;;AAwBE;;EAEE,gDAhEmB;AA2CvB;;AA0BE;;EAEE,gDAtEmB;AA+CvB;;AA4BE;;EAEE,sCAAA;AAzBJ;;AA8BE;;EAEE,eAAA;AA3BJ;;AAgCE;EACE,sBAAA;AA7BJ;;AAmCE;EACE,gDAAA;EACA,kDAjG2B;EAkG3B,mDAlG2B;EAmG3B,gBAAA;AAhCJ;;AAsCE;;EACE,gDAAA;EACA,kDA3G2B;EA4G3B,mDA5G2B;EA6G3B,gBAAA;AAlCJ;;AAuCE;EACE,kDAlH2B;EAmH3B,mDAnH2B;EAoH3B,iBAAA;AApCJ;;AAyCE;EACE,kDAzH2B;EA0H3B,mDA1H2B;AAoF/B;;AA2CE;EACE,kDA/H2B;EAgI3B,mDAhI2B;AAwF/B;;AA4CA;EACE,yBAAA;AAzCF;;AA4CA;EACE,gBAAA;AAzCF;;AA6CE;EACE,cAAA;EACA,gBAAA;AA1CJ;;AA8CA;EACE,cAAA;EACA,gBAAA;AA3CF;;AA8CA;EACE,gDAAA;AA3CF;;AA8CA;EACE,gBAAA;EACA,uBAAA;AA3CF","sourcesContent":["/* Ids Dropdown List Component */\n// These input field sizes come from the design tokens and are adjusted\n// here to account for 1px border size on top/bottom or left/right in some calculations.\n$border-input-size-xs: calc(var(--ids-input-width-10) - 2px);\n$border-input-size-sm: calc(var(--ids-input-width-20) - 2px);\n$border-input-size-md: calc(var(--ids-input-width-40) - 2px);\n$border-input-size-mm: calc(var(--ids-input-width-30) - 2px);\n$border-input-size-lg: calc(var(--ids-input-width-50) - 2px);\n$border-input-field-height-xs: calc(var(--ids-input-height-10) - 2px);\n$border-input-field-height-sm: calc(var(--ids-input-height-20) - 2px);\n$border-input-field-height-md: calc(var(--ids-input-height-30) - 2px);\n$border-input-field-height-lg: calc(var(--ids-input-height-40) - 2px);\n\n:host {\n  display: block;\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: var(--ids-input-width-40);\n  min-width: $border-input-size-xs;\n  width: var(--ids-input-width-full);\n  font-weight: normal;\n}\n\n:host(.multi-column) {\n  overflow-x: auto;\n}\n\n:host(.is-table) {\n  display: table;\n}\n\n:host(.is-datagrid[field-height='xs']),\n:host(.is-datagrid[field-height='xxs']) {\n  ::slotted(ids-list-box-option) {\n    font-size: var(--ids-font-size-xs);\n  }\n}\n\n// Width Sizes\n:host([size='xs']) {\n  &,\n  ::slotted(ids-list-box-option) {\n    max-width: $border-input-size-xs;\n  }\n}\n\n:host([disabled]:not([disabled='false'])) {\n  cursor: var(--ids-cursor-default);\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n:host([size='sm']) {\n  &,\n  ::slotted(ids-list-box-option) {\n    max-width: $border-input-size-sm;\n  }\n}\n\n:host([size='md']) {\n  &,\n  ::slotted(ids-list-box-option) {\n    max-width: $border-input-size-md;\n    min-height: 32px;\n  }\n}\n\n:host([size='mm']) {\n  &,\n  ::slotted(ids-list-box-option) {\n    max-width: $border-input-size-mm;\n  }\n}\n\n:host([size='lg']) {\n  &,\n  ::slotted(ids-list-box-option) {\n    max-width: $border-input-size-lg;\n  }\n}\n\n:host([size='full']) {\n  &,\n  ::slotted(ids-list-box-option) {\n    max-width: var(--ids-input-width-full);\n  }\n}\n\n:host([auto-size='true']) {\n  &,\n  ::slotted(ids-list-box-option) {\n    max-width: none;\n  }\n}\n\n:host([input-auto-size='false']) {\n  ::slotted(ids-list-box-option) {\n    margin-inline-end: 8px;\n  }\n}\n\n// Height Sizes\n:host([field-height='xxs']) {\n  ::slotted(ids-list-box-option) {\n    font-size: var(--ids-dropdown-font-size-compact);\n    min-height: $border-input-field-height-xs;\n    line-height: $border-input-field-height-xs;\n    text-indent: 2px;\n  }\n}\n\n:host([compact]),\n:host([field-height='xs']) {\n  ::slotted(ids-list-box-option) {\n    font-size: var(--ids-dropdown-font-size-compact);\n    min-height: $border-input-field-height-xs;\n    line-height: $border-input-field-height-xs;\n    text-indent: 4px;\n  }\n}\n\n:host([field-height='sm']) {\n  ::slotted(ids-list-box-option) {\n    min-height: $border-input-field-height-sm;\n    line-height: $border-input-field-height-sm;\n    text-indent: 10px;\n  }\n}\n\n:host([field-height='md']) {\n  ::slotted(ids-list-box-option) {\n    min-height: $border-input-field-height-md;\n    line-height: $border-input-field-height-md;\n  }\n}\n\n:host([field-height='lg']) {\n  ::slotted(ids-list-box-option) {\n    min-height: $border-input-field-height-lg;\n    line-height: $border-input-field-height-lg;\n  }\n}\n\n:host([uppercase]) ::slotted(ids-list-box-option) {\n  text-transform: uppercase;\n}\n\n:host(.module-nav) {\n  max-height: none;\n}\n\n:host(ids-list-box) {\n  ids-text.first-selected {\n    display: block;\n    padding: 5px 9px;\n  }\n}\n\n::slotted(ids-text.first-selected) {\n  display: block;\n  padding: 5px 9px;\n}\n\n::slotted(ids-list-box-option[selected].last-selected) {\n  margin-bottom: var(--ids-dropdown-group-padding);\n}\n\n::slotted(ids-list-box-option.ellipsis) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
